<template>
  <vue-modal
    :name="modalName"
    :pivotY="0.15"
    :width="widthModal"
    height="auto"
    :scrollable="true"
    :click-to-close="clickToClose"
    :classes="['generic-modals', 'v--modal']"
    @before-open="beforeOpenAction"
    @opened="openedAction"
    ref="vueModal"
  >
    <div class="content-modal content">
      <h2 class="text-center">{{ translations[title] }}</h2>
      <component
        :is="contentComponent"
        v-bind="dataComponent"
        ref="contentComponent"
        :paramsContentComponent="paramsContentComponent"
      ></component>

      <div slot="top-right" v-if="showCloseIcon">
        <button
          type="button"
          class="close-button"
          :id="`close-button-${modalName}`"
          title="Close"
          @click="$modal.hide(modalName)"
        >
          <span class="icon-close"></span>
        </button>
      </div>

      <div class="CTA-wrapper row text-center">
        <div
          class="small-10 large-8 center-column columns"
          v-if="ctaButton && closeButton"
        >
          <div class="large-5 columns">
            <button
              class="button secondary"
              :aria-label="translations[closeButton]"
              type="button"
              :id="`closeButton-${modalName}`"
              @click="$modal.hide(modalName)"
            >
              {{ translations[closeButton] }}
            </button>
          </div>
          <div class="large-5 columns set-right-justified">
            <button
              type="button"
              :id="`ctaButton-${modalName}`"
              class="button primary configurator2-replace-current-design-save"
              @click="ctaAction"
            >
              {{ translations[ctaButton] }}
            </button>
          </div>
        </div>

        <div
          class="small-10 large-4 center-column columns"
          v-else-if="ctaButton"
        >
          <button
            type="button"
            class="button primary"
            :id="`ctaButton-${modalName}`"
            :aria-label="translations[ctaButton]"
            @click="ctaAction()"
          >
            {{ translations[ctaButton] }}
          </button>
        </div>
      </div>
    </div>
  </vue-modal>
</template>

<script>
import productMissingModal from '@/components/Modals/ProductMissing';
import recipeDeclinedModal from '@/components/Modals/RecipeDeclined';
import startOverModal from '@/components/Modals/StartOver';
import favoritesModal from '@/components/Modals/Favorites';
import noWebglModal from '@/components/Modals/NoWebgl';

export default {
  name: "ModalWrapper",
  components: {
    productMissingModal,
    recipeDeclinedModal,
    startOverModal,
    favoritesModal,
    noWebglModal
  },
  props: {
    modalName: {
      type: String,
      required: true
    },
    title: String,
    contentComponent: {
      type: String,
      required: true
    },
    dataComponent: {
      default: Object,
      type: Object
    },
    closeButton: String,
    ctaButton: String,
    showCloseIcon: {
      default: true,
      type: Boolean
    },
    clickToClose: {
      default: true,
      type: Boolean
    },
    widthModal: {
      type: String,
      default: '75%'
    }
  },
  data() {
    return {
      paramsContentComponent: {}
    };
  },
  computed: {
    translations(){
      return this.$store.state.translations.data;
    }
  },
  methods: {
    /**
     * @function ctaAction
     * Method to call function from content component.
     * It will be called onlye if the method exist in child component.
     */
    ctaAction() {
      if (typeof this.$refs.contentComponent.ctaAction !== "undefined") {
        this.$refs.contentComponent.ctaAction();
      } else {
        this.$modal.hide(this.modalName);
      }
    },
    /**
     * @function beforeOpenAction
     * Method to receive the data sent to the modal.
     */
    beforeOpenAction(event) {
      this.paramsContentComponent = event.params;
    },
    /**
     * @function openedAction
     * Method to call method in child component when the modal became visible.
     */
    openedAction() {
      if (typeof this.$refs.contentComponent.openedAction !== "undefined") {
        this.$refs.contentComponent.openedAction(this.paramsContentComponent);
      }
    }
  }
};
</script>
